import type { PlatformSocialLinks, PlatformSocialNetwork } from '../types/admin';

export const PLATFORM_SOCIAL_NETWORKS: {
  id: PlatformSocialNetwork;
  label: string;
  placeholder: string;
}[] = [
  {
    id: 'facebook',
    label: 'Facebook',
    placeholder: 'https://www.facebook.com/jconsultmy',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    placeholder: 'https://www.instagram.com/jconsultmy',
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    placeholder: 'https://www.linkedin.com/company/jconsult-my-sarl',
  },
  {
    id: 'youtube',
    label: 'YouTube',
    placeholder: 'https://www.youtube.com/@jconsultmy',
  },
  {
    id: 'x',
    label: 'X (Twitter)',
    placeholder: 'https://x.com/jconsultmy',
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    placeholder: 'https://www.tiktok.com/@jconsultmy',
  },
];

export function emptyPlatformSocialLinks(): PlatformSocialLinks {
  return {
    facebook: '',
    instagram: '',
    linkedin: '',
    youtube: '',
    x: '',
    tiktok: '',
  };
}

export function normalizePlatformSocialLinks(raw: Partial<PlatformSocialLinks> | null | undefined): PlatformSocialLinks {
  const links = emptyPlatformSocialLinks();
  if (!raw) return links;
  for (const network of PLATFORM_SOCIAL_NETWORKS) {
    const value = raw[network.id];
    if (typeof value === 'string') {
      links[network.id] = value.trim();
    }
  }
  return links;
}
